import { useTrackView } from '#src/app/shared/hooks/tracking';

export function useTrackPageView(): void {
	useTrackView('ambassadors_lp_view');
}
